import React, { useState, useEffect, useContext } from 'react';

import staticData from '@utils/static/menu';
import SubMenu from './subMenu';
import { AuthContext } from '@shared/context/AuthContext';
import { useLocalStorage } from '@shared/auth/useLocalStorage';
import { NavLink, useNavigate } from 'react-router-dom';
import { isSubmenuInPermissions } from '@utils/static/commonUtils';

export function SidebarContainer() {
    const [permissions, setPermissions]: any = useState([]);
    const { removeItem } = useLocalStorage();
    const { user, setUser } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (user) {
            const permissionArr = user.user_role.user_permissions;
            setPermissions(permissionArr.map(ele => ele.slug));
        }
    }, [user]);

    const onLogout = () => {
        setUser(null);
        removeItem('user');
        navigate('/');
    };
    return (
        <React.Fragment>
            <div className="sidebar_cover">
                <div className="sidebar_item_box">
                    <ul className="main_sidebar_list_box" style={{ paddingRight: '16px' }}>
                        {(staticData.menuData || []).map((i: any, j: any) => (
                            <>
                                {i?.subMenu && isSubmenuInPermissions(i?.subMenu, permissions) && (
                                    <>
                                        <li className="heading_box">
                                            <span className="heading_item">{i.title}</span>
                                        </li>
                                        {(i?.subMenu || []).map((k: any, l: any) => (
                                            <SubMenu menu={k} key={l} permission={permissions} />
                                        ))}
                                    </>
                                )}
                            </>
                        ))}
                    </ul>
                </div>
            </div>
        </React.Fragment>
    );
}
